import { TableCell, TableRow } from "@material-ui/core";
import * as React from "react";
import { TABLE_LINE_HEIGHT } from "../../config";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { TableSelection } from "../hooks/useTableSelection";
import { CustomCheckbox } from "./CustomCheckbox";

type Props = {
    id: string;
    children: React.ReactNode;
    select?: TableSelection;
    hideCheckbox?: boolean;
};

export const TableLine = ({ id, children, select, hideCheckbox }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <TableRow style={{ display: "flex", height: TABLE_LINE_HEIGHT, flexGrow: 1 }}>
            {!hideCheckbox && select && (
                <TableCell style={{ display: "flex", alignItems: "center", padding: isMobile ? 12 : "0 36px 0 12px" }}>
                    <CustomCheckbox
                        onChange={() => {
                            select.toggleSelection(id);
                        }}
                        checked={select.isSelected(id)}
                        style={{ opacity: select.isSelected(id) ? 1 : 0.25 }}
                    />
                </TableCell>
            )}
            {children}
        </TableRow>
    );
};
